<template>
  <v-container class="v-container contact-us-container">
    <v-layout justify-center align-center>
      <v-flex xs12 sm10 md5 lg5>
        <div class="page-title">Contact Us</div>
        <div class="contact-form">
        <v-form @submit.prevent="submit()">
          <v-layout column class="login-layout">
            <v-flex xs12 sm10 md8 lg4>
              <input
                v-model="contactForm.email"
                :class="{ 'wrong-input': $v.contactForm.email.$invalid && showErrors }"
                type="email"
                placeholder="Email"
                id="contact-email"
                class="custom-input"
              />
            </v-flex>
            <v-flex xs12 sm10 md8 lg4>
              <input
                v-model="contactForm.name"
                :class="{ 'wrong-input': $v.contactForm.name.$invalid && showErrors }"
                type="text"
                placeholder="Your Name"
                id="contact-name"
                class="custom-input"
              />
            </v-flex>
            <v-flex xs12 sm10 md8 lg4>
              <vue-tel-input
                wrapperClasses="key-country"
                id="contact-phone"
                class="custom-input"
                :defaultCountry="defaultCountry"
                v-model="contactForm.phone"
              ></vue-tel-input>
            </v-flex>
            <v-flex xs12 sm10 md8 lg4>
              <textarea
                v-model="contactForm.description"
                :class="{ 'wrong-input': $v.contactForm.description.$invalid && showErrors }"
                style="height: auto"
                rows="12"
                placeholder="Description"
                id="contact-description"
                class="custom-input"
              />
            </v-flex>
            <p v-if="showErrors" class="error-message">
              <span v-if="!$v.contactForm.email.required">Email is required.</span>
              <span v-if="!$v.contactForm.email.email">The input must be a proper email!</span>
              <span v-if="!$v.contactForm.name.required">Title is required.</span>
              <span v-if="!$v.contactForm.name.minLength"
                >Title must have at least
                {{ $v.contactForm.name.$params.minLength.min }} letters.</span
              >
              <span v-if="!$v.contactForm.description.required">Description is required.</span>
              <span v-if="!$v.contactForm.description.minLength"
                >Description must have at least
                {{ $v.contactForm.description.$params.minLength.min }} letters.</span
              >
            </p>
            <v-flex xs12 sm12 md12 class="submit-button-container">
              <button class="submit-button" type="submit" id="submit-contact">Submit</button>
            </v-flex>
          </v-layout>
        </v-form>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import SimpleService from '@/services/SimpleService';
import AuthorizService from '../services/AuthorizService';
import VueTelInput from 'vue-tel-input';
import { mapActions, mapState } from 'vuex';

import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'ContactUs',
  components: {
    VueTelInput,
  },
  data() {
    return {
      contactForm: {
        email: '',
        name: '',
        description: '',
        phone: '',
      },
      defaultCountry: '',
      showErrors: false,
    };
  },
  computed: {
    ...mapState(['loginInfo']),
  },
  created() {
    var language =
      (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
      navigator.language || // All browsers
      navigator.userLanguage;
    if (language) {
      let isLanguage = language.split('-')[1];
      if (!isLanguage) {
        isLanguage = language.split('-')[0];
      }
      if (isLanguage) {
        this.defaultCountry = isLanguage;
      }
    }

    if (this.loginInfo.isLogged) {
      AuthorizService.getProfile().then((resp) => {
        this.contactForm.email = resp.data.email;
      });
    }
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    submit() {
      let jsonToSend = {
        email: this.contactForm.email,
        name: this.contactForm.name,
        text: this.contactForm.description,
      };
      if (this.contactForm.phone) {
        jsonToSend.phone = this.contactForm.phone;
      }
      if (!this.$v.contactForm.$invalid) {
        this.setLoading({ show: true, text: 'Submitting...' });
        SimpleService.contactUs(jsonToSend).then(
          (resp) => {
            this.showErrors = false;
            this.setLoading({ show: false, text: '' });
            this.contactForm = {
              email: '',
              name: '',
              description: '',
              phone: '',
            };
            this.showSnackbar(resp.data);
          },
          (err) => {
            this.setLoading({ show: false, text: '' });
            console.log(err);
          }
        );
      } else {
        this.showErrors = true;
      }
    },
  },
  validations: {
    contactForm: {
      description: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
        required,
      },
      name: {
        required,
        minLength: minLength(4),
      },
    },
  },
};
</script>

<style scoped>
.submit-button-container {
  margin-top: 30px;
}
#contact-phone {
  padding-left: 0;
}
.key-country /deep/ .dropdown {
  outline: none;
  background: transparent;
}
.v-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  justify-content: center;
  align-items: center;
}
.user-form {
  margin: auto;
}
.submit-button {
  margin-top: 0;
}
.contact-form {
  position: relative;
  -webkit-box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  background-color: #ffffff;
  margin-right: auto;
  margin-left: auto;
  padding: 46px 35px;
}

.error-message {
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #fd6262;
}

.error-message span {
  display: block;
}

.wrong-input {
  outline: 2px solid #fd6262 !important;
}

.registration-form {
  max-width: 450px;
}
.registration {
  
  margin-top: 14px;
  color: #216169;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
}
.custom-input {
  background-position-y: center;
  background-position-x: 10px;
  width: 100%;
  height: 46px;
  color: #216169;
  background-color: #c4c4c44d;
  font-size: 12px;
  margin-bottom: 17px;
  padding: 10px 10px 10px 20px;
}
</style>
